export function getHourMinSec(date) {
    const created = new Date(date)
    const now = new Date()
    let delta = Math.abs(now - created);
    return durationToHourMinSec(delta);
}

export function getMinSecReverse(duration) {
    let timer = duration, minutes, seconds;
    minutes = parseInt(timer / 60, 10);
    seconds = parseInt(timer % 60, 10);

    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    return minutes + ":" + seconds;
}

export function durationToHourMinSec(duration) {
    duration /= 1000
    let hours = Math.floor(duration / 3600);
    let minutes = Math.floor(duration / 60) % 60;
    duration -= minutes * 60;
    if ((minutes / 10) < 1) {
        minutes = "0" + minutes
    }
    let seconds = Math.floor(duration % 60);
    if ((seconds / 10) < 1) {
        seconds = "0" + seconds
    }
    let res = minutes + ":" + seconds;
    if (hours) {
        res = hours + ":" + res;
    }
    return res;
}

export function getNamedMonth(monthNum) {
    const arrMonth = {0: "january", 1: "february", 2: "march", 3: "april", 4: "may", 5: "june", 6: "july", 7: "august", 8: "september", 9: "october", 10: "november", 11: "december"}
    return arrMonth[monthNum] ?? monthNum;
}